module.exports = __webpack_public_path__ + "img/idx-lottery-title.894140c.webp";